import React, { Suspense } from 'react'
import { BasicDetailContextProvider } from './utils/BasicDetailContext'
import EventTabWrapper from './component/EventTabWrapper'
import DataLoader from '../../components/FinalMolGrid/ui/dataLoader/DataLoader'


const EventMangementForm = () => {
    return (
        <Suspense fallback={<DataLoader />}>
            <BasicDetailContextProvider>
                <EventTabWrapper />
            </BasicDetailContextProvider>
        </Suspense>
    )
}

export default EventMangementForm